var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Property 1=arrow_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.707 8.2859C18.5193 8.10292 18.2647 8.00012 17.9993 8.00012C17.7339 8.00012 17.4794 8.10292 17.2917 8.2859L12.7016 12.7621C12.5113 12.9403 12.2577 13.0397 11.994 13.0397C11.7302 13.0397 11.4766 12.9403 11.2863 12.7621L6.69623 8.2859C6.50746 8.1081 6.25463 8.00972 5.9922 8.01194C5.72977 8.01417 5.47873 8.11682 5.29316 8.29779C5.10758 8.47876 5.00232 8.72357 5.00004 8.97949C4.99776 9.23541 5.09864 9.48197 5.28096 9.66606L9.87006 14.1423C10.1489 14.4143 10.4799 14.63 10.8443 14.7772C11.2086 14.9244 11.5991 15.0001 11.9935 15.0001C12.3878 15.0001 12.7783 14.9244 13.1427 14.7772C13.507 14.63 13.838 14.4143 14.1169 14.1423L18.707 9.66606C18.8946 9.48302 19 9.2348 19 8.97598C19 8.71716 18.8946 8.46894 18.707 8.2859Z",
    fill: "#1A1B22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.e00531614f24b411c802b3a321ab10c2.svg";
export { ForwardRef as ReactComponent };